module.exports = __webpack_public_path__ + "dashboard/img/photo-film-music_dark.d81d49d8f5b4f3a33c64bdad2d34a233.svg";